(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finest-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('finest-promo-popup')) {
  customElements.define(
    'finest-promo-popup',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');

        if (!this.dialog || typeof this.dialog.showModal !== 'function') {
          return;
        }

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.editor = Boolean(
          window.Shopify && window.Shopify.designMode
        );

        this.key =
          'finest-popup:' +
          this.dataset.sectionId +
          ':' +
          this.dataset.campaign;

        this.querySelector('.finest-popup__close').addEventListener(
          'click',
          () => this.close(),
          options
        );

        this.dialog.addEventListener(
          'close',
          () => this.restoreScroll(),
          options
        );

        this.dialog.addEventListener(
          'click',
          (event) => {
            if (
              event.target !== this.dialog ||
              this.dataset.backdropClose !== 'true'
            ) {
              return;
            }

            const rect = this.dialog.getBoundingClientRect();

            if (
              event.clientX < rect.left ||
              event.clientX > rect.right ||
              event.clientY < rect.top ||
              event.clientY > rect.bottom
            ) {
              this.close();
            }
          },
          options
        );

        const button = this.querySelector('.finest-popup__button');

        if (button) {
          button.addEventListener(
            'click',
            () => this.close(),
            options
          );
        }

        if (this.editor) {
          document.addEventListener(
            'shopify:section:select',
            (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) {
                this.open();
              }
            },
            options
          );

          document.addEventListener(
            'shopify:section:deselect',
            (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) {
                this.close();
              }
            },
            options
          );

          if (this.dataset.preview === 'true') {
            this.timer = setTimeout(() => this.open(), 150);
          }

          return;
        }

        if (this.dataset.enabled !== 'true' || this.wasSeen()) {
          return;
        }

        this.timer = setTimeout(
          () => this.open(),
          Number(this.dataset.delay) * 1000
        );
      }

      wasSeen() {
        try {
          if (this.dataset.frequency === 'session') {
            return sessionStorage.getItem(this.key) === '1';
          }

          if (this.dataset.frequency === 'daily') {
            return (
              Date.now() -
                Number(localStorage.getItem(this.key) || 0) <
              86400000
            );
          }
        } catch (_) {
          // Storage may be blocked; the popup still works.
        }

        return false;
      }

      markSeen() {
        if (this.editor) return;

        try {
          if (this.dataset.frequency === 'session') {
            sessionStorage.setItem(this.key, '1');
          }

          if (this.dataset.frequency === 'daily') {
            localStorage.setItem(this.key, String(Date.now()));
          }
        } catch (_) {}
      }

      open() {
        if (!this.isConnected || this.dialog.open) return;

        // Wait if another visible modal is already open.
        const anotherModalIsOpen = Array.from(
          document.querySelectorAll(
            'dialog[open], [aria-modal="true"]'
          )
        ).some(
          (element) =>
            element !== this.dialog &&
            element.getClientRects().length &&
            getComputedStyle(element).visibility !== 'hidden'
        );

        if (!this.editor && anotherModalIsOpen) {
          this.timer = setTimeout(() => this.open(), 1000);
          return;
        }

        this.previousFocus = document.activeElement;
        this.previousOverflow =
          document.documentElement.style.overflow;

        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;

        this.markSeen();
      }

      restoreScroll() {
        if (!this.scrollLocked) return;

        document.documentElement.style.overflow =
          this.previousOverflow;

        this.scrollLocked = false;

        if (this.previousFocus && this.previousFocus.isConnected) {
          this.previousFocus.focus({ preventScroll: true });
        }
      }

      close() {
        clearTimeout(this.timer);

        if (this.dialog && this.dialog.open) {
          this.dialog.close();
        }

        this.restoreScroll();
      }

      disconnectedCallback() {
        this.close();

        if (this.controller) {
          this.controller.abort();
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
